<script setup lang="ts">
import type { TutorTask } from '../model/tutor-tasks/interfaces'

import { BadgeTutorTask } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'

import { useDisciplineTaskStatus } from '../model/discipline-task-status.hook'

defineOptions({
  name: 'DisciplineTaskStatus',
})

const props = defineProps<{
  task: TutorTask
}>()

const {
  refActorText,
} = useDisciplineTaskStatus({
  task: computed(() => props.task),
})
</script>

<template>
  <div class="discipline-task-status">
    <BadgeTutorTask :status="task.status" />
    <AppText
      v-if="refActorText"
      name="body1"
    >
      {{ refActorText }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineTaskStatus.scss" />
